// A login redirect carries the page the user was originally trying to reach,
// so a deep link (e.g. /billing/checkout?priceId=...) survives signing in
// instead of dropping them on the dashboard.
//
// The value round-trips through the URL, so it is attacker-controllable and
// must never be handed to a redirect unvalidated: an absolute URL, or a
// protocol-relative "//evil.com" (and its "/\evil.com" variant, which some
// browsers normalise the same way), would turn the login screen into an open
// redirect. Only a single-slash-prefixed same-origin path is accepted.
export const DEFAULT_REDIRECT = '/';

export const toSafeCallbackUrl = (callbackUrl) => {
  if (typeof callbackUrl !== 'string' || !callbackUrl) return DEFAULT_REDIRECT;
  if (!callbackUrl.startsWith('/')) return DEFAULT_REDIRECT;
  if (callbackUrl.startsWith('//') || callbackUrl.startsWith('/\\')) return DEFAULT_REDIRECT;
  return callbackUrl;
};

// Builds the /login destination for an unauthenticated request. The dashboard
// is where login already lands by default, so it is left off rather than
// round-tripped as a redundant query param.
export const buildLoginRedirect = (resolvedUrl) => {
  const target = toSafeCallbackUrl(resolvedUrl);
  return target === DEFAULT_REDIRECT ? '/login' : `/login?callbackUrl=${encodeURIComponent(target)}`;
};
